import {
    SET_SETTINGS,
    SET_DOWNLOAD_EVERYTHING,
    SET_RUN_CLIENTS_WITH_LOGGING,
    SET_RUN_CLIENTS_WITH_DX9,
    SET_SHOULD_MINIMIZE_TO_TRAY,
    SET_LOCALE,
    SET_TEST_SERVERS,
} from './constants'

export function setSettings(settings) {
    return {
        type: SET_SETTINGS,
        payload: settings,
    }
}

export function setDownloadEverything(downloadEverything) {
    return {
        type: SET_DOWNLOAD_EVERYTHING,
        payload: downloadEverything,
    }
}

export function setRunClientsWithLogging(runWithLogging) {
    return {
        type: SET_RUN_CLIENTS_WITH_LOGGING,
        payload: runWithLogging,
    }
}

export function setRunClientsWithDx9(runWithDx9) {
    return {
        type: SET_RUN_CLIENTS_WITH_DX9,
        payload: runWithDx9,
    }
}

export function setShouldMinimizeToTray(shouldMinimize) {
    return {
        type: SET_SHOULD_MINIMIZE_TO_TRAY,
        payload: shouldMinimize,
    }
}

export function setLocale(locale) {
    return {
        type: SET_LOCALE,
        payload: locale,
    }
}

export function setTestServers(testServers) {
    return {
        type: SET_TEST_SERVERS,
        payload: testServers,
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/settings/actions.js